var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSinglesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.448 12.9137L12.6329 19.2857C12.4279 19.5103 12.1765 19.6901 11.895 19.8132C11.6136 19.9363 11.3085 20 11 20C10.6915 20 10.3864 19.9363 10.105 19.8132C9.82353 19.6901 9.57205 19.5103 9.36711 19.2857L3.55204 12.9137C3.19644 12.5243 3 12.0212 3 11.5C3 10.9788 3.19644 10.4757 3.55204 10.0863L9.36711 3.71429C9.57205 3.48968 9.82353 3.30989 10.105 3.18677C10.3864 3.06365 10.6915 3 11 3C11.3085 3 11.6136 3.06365 11.895 3.18677C12.1765 3.30989 12.4279 3.48968 12.6329 3.71429L18.448 10.0863C18.8036 10.4757 19 10.9788 19 11.5C19 12.0212 18.8036 12.5243 18.448 12.9137Z",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinglesIcon);
export default __webpack_public_path__ + "static/media/singlesIcon.1cc4d68d901a4fa302e9ecf2ac856ec9.svg";
export { ForwardRef as ReactComponent };